import React from 'react';
import { Button, Select, Input } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { TERMINOLOGY_SYSTEMS, DEFAULT_SNOMED_SYSTEM } from './constants';

/**
 * Render terminology system select dropdown
 */
export const renderTerminologySystemSelect = (value, onChange, size = 'default') => (
  <Select value={value || DEFAULT_SNOMED_SYSTEM} onChange={onChange} style={{ width: '100%' }} size={size}>
    {TERMINOLOGY_SYSTEMS.map(({ value, label }) => (
      <Select.Option key={value} value={value}>{label}</Select.Option>
    ))}
  </Select>
);

/**
 * Render delete button
 */
export const renderDeleteButton = (onClick, size = 'default') => (
  <Button type="text" danger icon={<DeleteOutlined />} onClick={onClick} size={size} />
);

/**
 * Manual code/display entry for tagging a question/answer with a terminology code.
 * ponytail: openrp has no terminology lookup microservice (unlike the source project's
 * SNOMED/ICD10 search-as-you-type picker), so authors type the code + display text directly.
 * Upgrade path: swap this for a real search component if a terminology service is added.
 */
export const renderTerminologySelect = (config) => {
  const {
    systemUrl,
    value,
    defaultValue,
    onChange,
    size = 'default',
    placeholder = 'Terminology code...'
  } = config;

  const display = defaultValue?.display || '';

  return (
    <Input.Group compact style={{ display: 'flex' }}>
      <Input
        style={{ width: '45%' }}
        size={size}
        placeholder={placeholder}
        defaultValue={value}
        onBlur={(e) => {
          const code = e.target.value;
          onChange(code, code ? { id: code, code, display, system: systemUrl || DEFAULT_SNOMED_SYSTEM } : null);
        }}
      />
      <Input
        style={{ width: '55%' }}
        size={size}
        placeholder="Display text..."
        defaultValue={display}
        onBlur={(e) => {
          const nextDisplay = e.target.value;
          onChange(value, value ? { id: value, code: value, display: nextDisplay, system: systemUrl || DEFAULT_SNOMED_SYSTEM } : null);
        }}
      />
    </Input.Group>
  );
};

